import React, { useEffect, useState } from 'react'
import { get, post } from '../../util/request';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const EditProfile = (props) => {
  const [state, setState] = useState({
    profile: '',
    loading: true,
    form: {
      company_id: '',
      employee_id: '',
      employee_name: '',
      employee_email: '',
      employee_nik: '',
      departement_id: '',
      phone_no: ''
    },
    departementList: '',
  })

  const jwtToken = useSelector(state => state.auth.generateToken)
  const navigate = useNavigate();

  const handleValueChange = (newValue) => {
    let name = newValue.target.name
    let value = newValue.target.value

    setState(prevState => {
      return {
        ...prevState,
        form: {
          ...state.form,
          [name]: value

        }
      }
    })
  }

  useEffect(() => {
    let isMounted = true
    if (isMounted) {

      getProfile()
    }
    return () => isMounted === false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getProfile = () => {
    get(
      `public/api/v1/member/me`,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },
      },
      success => {
        setState(prevState => {
          return {
            ...prevState,
            // tasksList: success.data.Data,
            profile: success.data.Data,
            form: {
              company_id: success.data.Data.company_id,
              employee_id: success.data.Data.employee_id,
              employee_name: success.data.Data.employee_fullname,
              employee_email: success.data.Data.employee_email,
              employee_nik: success.data.Data.employee_nik,
              departement_id: success.data.Data.departement.departement_id,
              phone_no: success.data.Data.profile.phone_no,
            },
            loading: false
          }
        })
      getDepartement(success.data.Data.company_id)

      },
      error => {
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )
  }

  const getDepartement = (id) => {
    get(
      `public/api/v1/departement_list?company_id=`+ id,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },
      },
      success => {
        setState(prevState => {
          return {
            ...prevState,
            // tasksList: success.data.Data,
            departementList: success.data.Data,
            loading: false
          }
        })
      },
      error => {
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )
  }


  const HandleEditProfile = () => {
    post(
      `public/api/v1/member/me`,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },
      },
      state.form,
      success => {
        navigate('/profile')
      },
      error => {
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )
  }

  const handleSelectedDepartement = (e) => {
    setState(prevState => {
      return {
        ...prevState,
        form: {
          ...state.form,
          departement_id: e.target.value
        }
      }
    })
  }
  return (
    !state.loading ?
      <div className='w-full h-screen grid-cols-1 sm:grid-cols-2 bg-real-white'>
        <div className='w-full h-20 bg-real-white'>
          <div className='flex items-center h-full px-4'>
          <a href={process.env.PUBLIC_URL + "/profile"}>
              <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/arrow-left.svg"} className='justify-start w-10 py-1' />
            </a>
            <p className='px-4'>Edit Profile</p>
          </div>
        </div>

        <div className='w-full px-4 py-2'>
          <div className="mt-2.5">
            <input
              type="text"
              name="employee_nik"
              id="employee_nik"
              placeholder='NIP'
              value={state.form.employee_nik}
              onChange={(e) => handleValueChange(e)}
              className="block w-full rounded-md border-0 px-3.5 py-4 bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>

        </div>

        <div className='w-full px-4 py-2'>
          <div className="mt-2.5">
            <input
              type="text"
              name="employee_name"
              id="employee_name"
              placeholder='Name'
              onChange={(e) => handleValueChange(e)}
              value={state.form.employee_name}
              className="block w-full rounded-md border-0 px-3.5 py-4 bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>

        </div>

        <div className='w-full px-4 py-2'>
          <div className="mt-2.5">
            <input
              type="text"
              name="employee_email"
              id="employee_email"
              placeholder='Email / ID Karyawan'
              onChange={(e) => handleValueChange(e)}
              value={state.form.employee_email}
              className="block w-full rounded-md border-0 px-3.5 py-4 bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>

        </div>

        <div className='w-full px-4 py-2'>
          <select id="departement" onChange={(e) => handleSelectedDepartement(e)} value={state.form.departement_id} class="bg-bg-primary border border-bg-primary text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-4 dark:focus:ring-blue-500 dark:focus:border-blue-500">
           {state.departementList === "" ? "" : state.departementList?.map((item, index) => (
            <option key={index} value={item.departement_id}>{item.departement_title}</option>
                  ))}
            
          </select>

        </div>

        <div className='w-full px-4 py-2'>
          <div className="mt-2.5">
            <input
              type="text"
              name="phone_no"
              id="phone_no"
              placeholder='Phone Number'
              onChange={(e) => handleValueChange(e)}
              value={state.form.phone_no}
              className="block w-full rounded-md border-0 px-3.5 py-4 bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>

        </div>
        <div className='w-full px-4 bg-real-white'>


          <div className='w-full p-4 border-b border-gray-200'>
          </div>
          <div className='w-full h-full py-4'>
            <button onClick={() => HandleEditProfile()} className="block w-full p-8 rounded-full bg-gradient-to-b from-red-light-bg to-orange-bg hover:bg-gradient-to-b hover:from-red-dark-bg hover:to-orange-dark-bg py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
              SIMPAN
            </button>
          </div>
          <div className='w-10/12 h-full py-4 mx-auto'>
            <a href='/home' className="block px-8 rounded-full border text-red-light-bg border-red-light-bg hover:bg-red-light-bg hover:text-white py-2.5 text-center text-sm font-semibold shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
              Ganti Kata Sandi?
            </a>
          </div>
        </div>
      </div >
      : ''
  )
}

export default EditProfile